import { PlusIcon } from '@heroicons/react/24/solid';
import { Button } from '@material-tailwind/react';
import { Link, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { formatPrice } from '../services/formatPrice';
import '../styles/ProductCard.css';

type ProductCardProps = {
  id: string;
  name: string;
  price: number;
  images: ProductImage[];
};

type ProductImage = {
  imageUrl: string;
  productId: string;
};

function ProductCard({ id, name, price, images }: ProductCardProps) {
  const navigate = useNavigate();
  const [currentImage, setCurrentImage] = useState<string>(images[0]?.imageUrl || 'https://via.placeholder.com/200x200');

  const handleMouseEnter = () => {
    if (images.length > 1) {
      setCurrentImage(images[1].imageUrl);
    }
  };

  const handleMouseLeave = () => {
    setCurrentImage(images[0]?.imageUrl || 'https://via.placeholder.com/200x200');
  };

  return (
    <div className="card">
      <Link to={`/product-detail/${id}`}>
        <img
          className="card-img"
          style={{height:"450px"}}
          src={currentImage}
          alt={name}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        />
      </Link>
      <div className="p-5 text-center pt-2">
        <Link to={`/product-detail/${id}`}>
          <strong className="card-title">{name}</strong>
        </Link>
        <br></br>
        <span className="card-price">{formatPrice(price)}</span>
        <Button placeholder={""}
          className="add-to-cart-btn"
          color="white"
          onClick={() => navigate(`/product-detail/${id}`)}
        >
          <PlusIcon className="text-black" width={20} height={20} />
        </Button>
      </div>
    </div>
  );
}

export default ProductCard;
